<template>
  <div class="backgroud-white cs-courseSchedule-editor">
    <div class="backgroud-gray-popup popup-content-area-small">
      <el-row>
        <el-col :span="12">
          <el-form
            ref="model"
            :rules="rules"
            :model="model"
            label-width="100px"
          >
            <el-form-item
              label="课程"
              prop="Name"
            >
              {{dataIn.courseName}}
            </el-form-item>
            <el-form-item
              label="老师"
              prop="Name"
            >
              {{dataIn.teacherName}}
            </el-form-item>
            <el-form-item
              label="校区"
              prop="Name"
              v-if="dataIn.courseType == 3"
            >
              {{dataIn.campusName}}
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="12">
          <el-form
            ref="model"
            :rules="rules"
            :model="model"
            label-width="100px"
          >
            <el-form-item
              label="课程"
              prop="courseId"
            >
              <el-select
                filterable
                v-on:change="onCourseChange()"
                v-model="model.courseId"
                placeholder="请选择课程"
              >
                <el-option
                  v-for="item in courseList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="老师"
              prop="teacherId"
            >
              <el-select
                filterable
                v-on:change="onTeacherChange()"
                v-model="model.teacherId"
                placeholder="请选择老师"
              >
                <el-option
                  v-for="item in teacherList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
              <!-- <span v-else> {{dataIn.teacherName}}</span> -->
            </el-form-item>
            <el-form-item
              label="校区"
              prop="campus"
              v-if="dataIn.courseType == 3"
            >
              <el-select
                filterable
                v-on:change="onCampusChange()"
                v-model="model.campusId"
                placeholder="请选择校区"
              >
                <el-option
                  v-for="item in campusList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" class="cs-transfer-container">
          <el-transfer
            v-model="selectedStudentList"
            :titles="['原课程', '新课程']"
            :props="{
                          key: 'Id',
                          label: 'Phone'
                        }"
            :data="studentList"
          >
          </el-transfer>
        </el-col>
      </el-row>
    </div>
    <div
      slot="footer"
      class="dialog-footer popup-footer"
    >
      <el-row>
        <el-col
          class="footer-right"
          :span="4"
        >
          <el-button
            type="primary"
            @click="save()"
          >确认</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-right {
  float: right;
}
.cs-transfer-container{
  text-align: center;
  .el-transfer{
    text-align: left;
    display: inline-block;
  }
}
</style>

<script>
import { reassignSignIn } from "../../service/signInManage.service";
import {
  getCoursesWithTerm,
  getTrainingCourses,
  getTeacherList,
  getStudentByCourse
} from "../../service/speedupCourse.service";
import { getCampusList } from "../../service/common.service";

export default {
  props: {
    dataIn: {
      universityGroupNumber: Number,
      termId: Number,
      categoryId: Number,
      courseType: Number,
      courseId: Number,
      teacherId: Number,
      campusId: Number,
      courseName: String,
      teacherName: String,
      campusName: String
    }
  },
  data() {
    return {
      teacherList: [],
      courseList: [],
      studentList: [],
      selectedStudentList: [],
      campusList: [],
      model: {
        courseId: "",
        teacherId: "",
        campusId: ""
      },
      rules: {
        courseId: [
          {
            required: true,
            message: "课程是必须的",
            trigger: "blur"
          }
        ],
        teacherId: [
          {
            required: true,
            message: "老师是必须的",
            trigger: "blur"
          }
        ]
      }
    };
  },
  components: {},
  created() {
    this.init();
    getCampusList().then(result => {
      if (!!result && result.success) {
        this.campusList = result.data;
      }
    });
  },
  methods: {
    init(){    
      this.loadCourseList();
      this.loadTeacherList();
      this.loadStudentList();
    },
    onCourseChange() {},
    onTeacherChange() {},
    onCampusChange() {},
    checkAllInputs(value, onlyCheck) {
      let isValid = true;
      this.$refs["model"].validate(valid => {
        if (!valid) {
          isValid = false;
          return;
        }
      });
      return isValid;
    },
    save() {
      if (!this.checkAllInputs()) {
        return;
      }
      if (this.selectedStudentList.length == 0) {
        this.$message({
          message: "未选择任何学生",
          type: "warning"
        });
        return;
      }

      reassignSignIn(this.dataIn.courseId, this.dataIn.teacherId, this.dataIn.campusId, this.model.courseId, 
        this.model.teacherId, this.model.campusId, this.selectedStudentList).then(
          result =>{
            if (result && result.success){
              this.$message({
                message: "重新分配学生签到成功",
                type: "success"
              });
              this.$emit("saveSuccess");
              this.close();
            }else{
              this.$message({
                message: "重新分配学生签到失败",
                type: "warning"
              });
            }
          }
        );
    },
    close() {
      this.$refs["model"].resetFields();
      this.$emit("close");
    },
    loadCourseList() {
      if (this.dataIn.courseType == 1) {
        if (
          !!this.dataIn &&
          !!this.dataIn.termId &&
          !!this.dataIn.universityGroupNumber
        ) {
          getCoursesWithTerm(
            this.dataIn.termId,
            this.dataIn.universityGroupNumber,
            true
          ).then(result => {
            if (!!result && result.success) {
              this.courseList = result.data.filter(i => i.Id != this.dataIn.courseId);
            }
          });
        }
      } else if (this.dataIn.courseType == 3) {
        if (!!this.dataIn && !!this.dataIn.categoryId && !!this.dataIn.termId) {
          getTrainingCourses(this.dataIn.termId, this.dataIn.categoryId).then(
            result => {
              if (!!result && result.success) {
                this.courseList = result.data;
              }
            }
          );
        }
      }
    },
    loadTeacherList(){
      getTeacherList(this.dataIn.categoryId).then(result=>{
        if (result && result.success){
          this.teacherList = result.data;
          this.model.teacherId = this.dataIn.teacherId;
        }
      });
    },
    loadStudentList(){
      getStudentByCourse(this.dataIn.courseId, this.dataIn.teacherId, this.dataIn.campusId).then(result=>{
        if (result && result.success){
          this.studentList = result.data;
        }
      });
    }
  },
  watch: {
    dataIn: function() {
      this.init();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/signInManage/signInReassign.vue